import type { ThemeV3 } from '../types/themeTypes';

export const macroLightTheme = {
  id: 'Macro Light',
  name: 'Macro Light',
  version: 3,
  mode: 'light',
  colorTokens: {
    'surface-0': 'oklch(0.964 0 59deg)',
    'surface-1':
      'color-mix(in srgb, var(--color-surface-0) 30%, var(--color-surface-4))',
    'surface-2':
      'color-mix(in srgb, var(--color-surface-0) 15%, var(--color-surface-4))',
    'surface-3':
      'color-mix(in srgb, var(--color-surface-0) 7%, var(--color-surface-4))',
    'surface-4': 'oklch(1 0 59deg)',
    'content-0': 'oklch(0.16 0 59deg)',
    'content-1': 'oklch(0.4 0 59deg)',
    'content-2': 'oklch(0.45 0 59deg)',
    'content-3': 'oklch(0.55 0 59deg)',
    'content-4': 'oklch(0.7 0 59deg)',
    edge: 'oklch(0.91 0 59deg)',
    'edge-muted': 'oklch(0.92 0 59deg)',
    accent: 'oklch(0.65 0.2 59deg)',
    red: 'oklch(63.7% 0.237 25.331)',
    orange: 'oklch(70.5% 0.213 47.604)',
    amber: 'oklch(76.9% 0.188 70.08)',
    yellow: 'oklch(79.5% 0.184 86.047)',
    lime: 'oklch(76.8% 0.233 130.85)',
    green: 'oklch(72.3% 0.219 149.579)',
    teal: 'oklch(71.05% 0.1276 181.6)',
    cyan: 'oklch(79.06% 0.1438 215.2)',
    blue: 'oklch(62.3% 0.214 259.815)',
    violet: 'oklch(60.6% 0.25 292.717)',
    purple: 'oklch(62.7% 0.265 303.9)',
    pink: 'oklch(65.6% 0.241 354.308)',
    surface: 'var(--layer-surface)',
    inset: 'var(--layer-inset)',
    ink: 'var(--color-content-0)',
    'ink-muted': 'var(--color-content-1)',
    'ink-subtle': 'var(--color-content-2)',
    'ink-disabled': 'var(--color-content-3)',
    'ink-placeholder': 'var(--color-content-4)',
    link: 'var(--color-accent)',
    'link-hover': 'var(--color-accent)',
    'link-visited': 'var(--color-accent)',
    page: 'var(--color-surface-0)',
    panel: 'var(--color-surface-4)',
    dialog: 'var(--color-surface-3)',
    menu: 'var(--color-surface-3)',
    tooltip: 'var(--color-surface-2)',
    toast: 'var(--color-surface-2)',
    input: 'transparent',
    'input-focus': 'var(--color-surface-1)',
    message: 'var(--color-surface-1)',
    hover: 'color-mix(in oklch, var(--color-content-0) 3%, transparent)',
    active: 'color-mix(in oklch, var(--color-content-0) 6%, transparent)',
    selected: 'color-mix(in oklch, var(--color-accent) 8%, transparent)',
    success: 'var(--color-green)',
    warning: 'var(--color-yellow)',
    failure: 'var(--color-red)',
    chrome:
      'color-mix(in oklch, var(--color-surface-3) 98%, var(--color-content-0))',
  },
} satisfies ThemeV3;
